import { cn } from '@/lib/utils'

interface IProps {
    className?: string
    colorBgClass?: string
}

export default function LoadingBar({
    className,
    colorBgClass = 'bg-card',
}: IProps) {
    return (
        <div
            className={cn(
                'relative w-full h-1 bg-primary overflow-hidden',
                className,
            )}
        >
            <div
                className={cn(
                    'absolute inset-0 size-full animate-wave',
                    colorBgClass,
                )}
            ></div>
        </div>
    )
}
